import React from "react";
import MinimalPublicPage from "./MinimalPublicPage";

export default function TrustAndSafetyPage() {
  return (
    <MinimalPublicPage
      eyebrow="Trust & safety"
      title="Small queues need strong rules."
      description="Ouro uses verification, reporting, moderation, and reputation together so the player pool stays worth protecting."
      points={[
        {
          title: "Identity friction",
          body: "The queue is designed to be harder for bad actors to re-enter casually.",
        },
        {
          title: "Reviewable behavior",
          body: "Reports and server-side signals give moderators more than a scoreboard snapshot.",
        },
        {
          title: "Clear accountability",
          body: "Players build a history that can help or hurt future access to the community.",
        },
      ]}
      secondaryLabel="Reputation"
      secondaryTo="/reputation"
    />
  );
}
